import React from 'react'
import { LazyLoad } from '../../common/Functions'

function Ecosystem() {
  return (
  <section className="max-w-screen-xl	mx-auto text-center">
    <div className="container mx-auto flex flex-wrap flex-col md:flex-row items-start justify-between py-10 px-0">
      <div className="w-full flex flex-col justify-center items-center">
        <div className="content px-20 pb-20">
          <p className="text-left font-bold text-2xl">
            About the Project
          </p>
          <p className="text-left text-lg text-gray-600">
CaseEvict is a freelance project I used to work with during the Pandemic. The agency that I have worked with provided a functional scope document with the defined features, whereas I followed the process flow and the design objective. The system allows clients to create their account, file cases related to the property, and search for the law agencies who will be managing their property cases. Also, law agencies can set up their profile, manage courts filling schedules, and manage which property cases to handle. There are three different types of registered users - client, law agency, and administrator. I worked on the client and law agency web portals only.
          </p>
        </div>
        <div className="content px-20 pb-20">
          <p className="text-left font-bold text-2xl">
            My Role in the Project
          </p>
          <p className="text-left text-lg text-gray-600">
            I was a freelance UI/UX Designer for this project. My goal is to provide a user-friendly and appealing interface for its users. I designed the UI components of web mockups then shared with the client an Adobe XD link where they can use it for their front-end development.
          </p>
        </div>
        <em className="text-gray-400 mb-10">Case Evict Tenant and Law Agency Web App Mock-ups</em>
        <LazyLoad src={require('../../common/images/caseevict/web-mockup.png')} alt="Case Evict Web Mockup"/>
      </div>
    </div>
  </section>
  )
}

export default Ecosystem
